import React, { useContext, useState, useEffect } from 'react';

import { DataContext } from '../../../context/DataContext';

import NewDialog from './NewDialog';
import MedicoInstitucion from './MedicoInstitucion';

import useFetchHook from '../../../hooks/customHook';

import { updateInstitution } from '../../../actions/mainForm';
import { form5Validator } from '../../../validators/MainFormValidator';
import { basicMsg, simpleConfirmDialog } from '../../../helpers/swal_msg';

import {
    Button, Dialog, DialogActions, DialogContent,
    DialogTitle, Slide, AppBar, Toolbar, IconButton,
    Typography, List, ListItemButton, ListItemText,
    Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { INSTITUTION_DEFAULT } from '../../../constants/form_const';

const Transition = React.forwardRef(function Transition(
    props, ref,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const InstitucionDialog = ({
    dialogStatus, setDialogStatus,
    doctorInstitutions, setDoctorInstitutions,
    setMedicos, institution_types
}) => {
    const { setData } = useContext(DataContext);
    const { protectedFetchReq } = useFetchHook();

    const { dialog2, dialog3, dialog4 } = dialogStatus;
    const { idMedicoEspecialista, institutions } = doctorInstitutions;

    const [institution, setInstitution] = useState(INSTITUTION_DEFAULT);

    useEffect(() => {
        if (dialog2)
            setInstitution(INSTITUTION_DEFAULT);
    }, [dialog2]);

    const handleCloseMainDialog = () => {
        setDialogStatus(e => ({ ...e, dialog2: false, dialog3: false }));
    };
    const handleClose = () => {
        setDialogStatus(e => ({ ...e, dialog2: true, dialog3: false }));
    };

    const editInstitution = idHospital => () => {
        const i = institutions.findIndex(u => u.idHospital === idHospital);
        if (i > -1) {
            setInstitution(e => ({ ...e, idMedicoEspecialista, ...institutions[i] }));
            setDialogStatus(e => ({ ...e, dialog2: false, dialog3: true }));
        } else basicMsg('No se encontró la institución');
    };

    // validar información y actualizar institución
    const updateFn = async () => {
        if (form5Validator(institution)) {
            if (await simpleConfirmDialog('¿Actualizar institución?', 'Sí, actualizar')) {
                await updateInstitution(
                    institution, setMedicos, setDialogStatus, setData, protectedFetchReq
                );
            }
        }
    };

    // abrir modal para nueva institución
    const saveNewInstitutions = () => {
        setInstitution(e => ({ ...e, idMedicoEspecialista }));
        setDialogStatus(e => ({ ...e, dialog2: false, dialog4: true }));
    };

    return (
        <>
            <Dialog
                fullScreen
                open={ dialog2 }
                onClose={ handleCloseMainDialog }
                slots={{ transition: Transition }}
                slotProps={{ transition: { direction: 'up' } }}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={ handleCloseMainDialog }
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Instituciones
                        </Typography>
                        <Button autoFocus color="inherit" onClick={ saveNewInstitutions }>
                            Nueva
                        </Button>
                    </Toolbar>
                </AppBar>
                <List>
                    {
                        institutions.map(({
                            idHospital, address
                        }, index) =>
                            <React.Fragment key={idHospital}>
                                <ListItemButton onClick={ editInstitution(idHospital) }>
                                    <ListItemText
                                        primary={ `Institución #${index + 1}` }
                                        secondary={ address }
                                    />
                                </ListItemButton>
                                {
                                    (institutions.length - 1 === index) &&
                                        <Divider />
                                }
                            </React.Fragment>
                        )
                    }
                </List>
            </Dialog>
            
            <Dialog
                open={ dialog3 }
                maxWidth='lg'
                fullWidth={true}
                onClose={ handleClose }
                aria-labelledby="hospital-dialog-title"
                aria-describedby="hospital-dialog-description"
                sx={{ zIndex: 1000 }}
            >
                <DialogTitle id="hospital-dialog-title">
                    <IconButton
                        aria-label="close"
                        onClick={ handleClose }
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    Institución de Médico
                </DialogTitle>
                <DialogContent>
                    <MedicoInstitucion
                        institution={ institution }
                        setInstitution={ setInstitution }
                        institution_types={ institution_types }
                        show_address={ true }
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={
                        () => setDialogStatus(e => ({ ...e, dialog2: false, dialog3: false }))
                    }>
                        Salir
                    </Button>
                    <Button variant="contained" onClick={ updateFn }>
                        Actualizar
                    </Button>
                </DialogActions>
            </Dialog>
            <NewDialog
                dialog4={ dialog4 }
                institution={ institution }
                setInstitution={ setInstitution }
                setDialogStatus={ setDialogStatus }
                setDoctorInstitutions={ setDoctorInstitutions }
                setMedicos={ setMedicos }
                institution_types={ institution_types }
            />
        </>
    );
};

export default InstitucionDialog;